// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J7lJzC4zru8MJN6MJmfT {
    white-space: pre-wrap;
    margin: 0;
    font-size: 13px;
    color: #32445A;
    background-color: initial;
    font-family: "Open Sans", sans-serif;
    border: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-activities/activity-item.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,SAAS;IACT,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,oCAAoC;IACpC,YAAY;AAChB","sourcesContent":[".noteContents {\n    white-space: pre-wrap;\n    margin: 0;\n    font-size: 13px;\n    color: #32445A;\n    background-color: initial;\n    font-family: \"Open Sans\", sans-serif;\n    border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noteContents": `J7lJzC4zru8MJN6MJmfT`
};
export default ___CSS_LOADER_EXPORT___;
